
import { Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import ActionMenu from "../molecules/ActionMenu.vue";
import UserSelector from "../molecules/UserSelector.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import PDAnalyticsChart from "../atoms/PDAnalyticsChart.vue";
import { SelectableProfile, UserPDStats, LabelAndValue } from "../../types";
import { StatsItemEnum, SystemApi } from "../../autogen";
import UIkit from "uikit";
import { print } from "../../helpers/view-utils";
import ChartViewMixin from "../../helpers/mixins/chart-view";
import Store from "../../store";
import { InstructionLevel } from "../../types";
interface PdAnalyticsCSVMenu extends LabelAndValue {
  type: StatsItemEnum;
}
[];
type menuItem = {
  label: string;
  value: string;
  type: StatsItemEnum;
};
@Options({
  components: {
    Page,
    ActionButton,
    ActionMenu,
    UserSelector,
    DepartmentUserSelector,
    PDAnalyticsChart
  }
})
export default class PDAnalytics extends ChartViewMixin {
  selectedUsers: SelectableProfile[] = [];
  stats: (UserPDStats & { size: number })[] = [];
  activePath = "main";
  focusedUser: Partial<UserPDStats> = {};
  zoom = "out";
  targetStats = StatsItemEnum.PdAnalytics;
  participantsMin = 2;
  participantsMax = 50;
  loadingFunction = true;
  menuItems: menuItem[] = [
    {
      label: "性格・パーソナリティ",
      value: "static",
      type: StatsItemEnum.PdAnalyticsStatic
    },
    {
      label: "社会性・欲求",
      value: "dynamic",
      type: StatsItemEnum.PdAnalyticsDynamic
    }
  ];
  chartRef?: HTMLElement;
  expansionRef?: HTMLElement;
  departmentUserSelectorFormKey = 0;
  tutorialImagePath = require("@/assets/image/PDTutorial.png");

  mounted() {
    this.$nextTick(() => {
      this.chartRef = this.$refs.chartRef as HTMLElement;
      this.expansionRef = this.$refs.expansionRef as HTMLElement;
    });
  }

  async onSelectionDone() {
    this.stats = this.selectedUsers.map(selectedUser => ({
      id: selectedUser.id,
      name: `${selectedUser.lastName} ${selectedUser.firstName}`,
      department: selectedUser.department,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      axis: this.chartData![selectedUser.id].stats[StatsItemEnum.PdAnalytics]!,
      size: this.chartRef ? this.chartRef.clientWidth / 3.5 : 200
    }));
  }
  onUserSelect(selectedUser: SelectableProfile) {
    this.focusedUser = selectedUser;
  }
  async onCsvButtonClick(item: PdAnalyticsCSVMenu) {
    if (this.selectedUsers.length === 0) {
      Store.getInstance().setInstructionContent(
        InstructionLevel.Confirm,
        `全データが出力されますが、よろしいですか？\nデータが多いと時間がかかる場合があります。`,
        async () => {
          try {
            this.downLoadCsvFile(item, ["all"]);
          } catch (err) {
            Store.getInstance().setInstructionContent(
              InstructionLevel.Alert,
              "エラーが発生しました。時間を置いて再度試すか、窓口までお問い合わせください。"
            );
          }
        }
      );
    } else {
      const Employees = this.selectedUsers.map(user => user.id);
      this.downLoadCsvFile(item, Employees);
    }
  }
  private async downLoadCsvFile(menuItem: menuItem, Employees: string[]) {
    Store.getInstance().setIsLoading(true);

    const encoding = require("encoding-japanese");
    try {
      const responseStatic = await new SystemApi().printCsv({
        type: menuItem.type,
        peopleIds: Employees
      });

      const str_array = encoding.stringToCode(responseStatic.data);
      const sjis_array = encoding.convert(str_array, "SJIS", "UNICODE");
      const uint8_array = new Uint8Array(sjis_array);

      const url = window.URL.createObjectURL(new Blob([uint8_array], { type: "text/csv;charset=Shift_JIS" }));
      const anchor = document.createElement("a");
      document.body.appendChild(anchor);
      anchor.setAttribute("href", url);
      anchor.setAttribute("download", `PD分析_${menuItem.label}_${new Date().toISOString()}.csv`);
      anchor.click();
      anchor.remove();
      document.body.onfocus = null;
    } catch (err) {
      let errMessage = "エラーが発生しました。時間を置いて再度試すか、窓口までお問い合わせください。";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    } finally {
      Store.getInstance().setIsLoading(false);
    }
  }
  onChartClick(item: UserPDStats) {
    this.zoom = "out";
    this.focusedUser = item;
    if (this.expansionRef) {
      UIkit.modal(this.expansionRef).show();
    }
  }
  getExpandedSize() {
    return window.innerHeight * 0.7;
  }
  onZoomButtonClick(inOut: "in" | "out") {
    this.zoom = inOut;
  }
  onPrintButtonClick() {
    print(StatsItemEnum.PdAnalytics, this.focusedUser, { zoom: this.zoom });
  }
}
